// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__3GoWY","goods":"styles_goods__2KXtz","wrapper":"styles_wrapper__2k6iX","categories":"styles_categories__gJWmt"};